<template>
    <v-container class="fill-height" fluid>

        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Petunjuk Paket</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark color="accent" class="black--text" @click="mulai" v-if="mapel.paket_ujian&&mapel.paket_ujian[item]">Mulai</v-btn>
                </v-toolbar>
                <v-container class="fill-height">
                    <v-layout row justify-center :class="{'pa-4': $vuetify.breakpoint.smAndDown, 'pa-10': $vuetify.breakpoint.mdAndUp}">
                        <v-flex xs10>
                            <div class="text-center font-weight-bold dark-grey--text" v-if="mapel.paket_ujian&&mapel.paket_ujian[item]">
                                <p class="headline font-weight-bold">Petunjuk Penggunaan Paket {{mapel.paket_ujian[item].nama_paket}}</p>
                                <p v-sanitize="mapel.paket_ujian[item].petunjuk"></p>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="expiryDialog" persistent max-width="500px">
            <v-card class="pa-2">
                <v-card-title class="text-h6 text-md-h5 font-weight-bold error--text">
                    <v-icon color="error" class="mr-3" size="30">mdi-clock-alert</v-icon>
                    Paket Sudah Kadaluarsa
                    </v-card-title>
                    
                    <v-card-text class="pb-0">
                    <p class="text-body-1 black--text">{{ expiryMessage }}</p>
                    <p v-if="expiredDate" class="font-weight-medium">
                        Tanggal Kadaluarsa: {{ expiredDate }}
                    </p>
                    <p class="text-body-2 text--secondary">
                        Silakan hubungi admin untuk perpanjangan atau redeem kode buku baru.
                    </p>
                    </v-card-text>

                    <v-card-actions class="pa-4">
                    <v-row justify="space-between">
                        <v-col cols="12" sm="auto" class="mb-2 mb-sm-0">
                        <v-btn
                            large
                            block
                            depressed
                            color="grey lighten-3"
                            class="black--text"
                            @click="goToHome"
                        >
                            <v-icon left>mdi-chevron-left</v-icon>
                            Kembali
                        </v-btn>
                        </v-col>
                        <v-col cols="12" sm="auto">
                        <v-btn
                            large
                            block
                            depressed
                            color="primary"
                            @click="openRedeemDialog"
                        >
                            <v-icon left>mdi-plus-circle</v-icon>
                            Redeem Kode Baru
                        </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="noAccessDialog" persistent max-width="500px">
            <v-card class="pa-2">
                <v-card-title class="text-h6 text-md-h5 font-weight-bold warning--text">
                    <v-icon color="warning" class="mr-3" size="30">mdi-lock-clock</v-icon>
                    Ujian Belum Bisa Diakses
                </v-card-title>
                <v-card-text class="pb-0">
                    <p class="text-body-1 black--text">{{ noAccessMessage }}</p>
                    <p class="text-body-2 text--secondary">
                        Silakan tunggu hingga waktu yang ditentukan atau hubungi admin untuk informasi lebih lanjut.
                    </p>
                </v-card-text>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn large depressed color="primary" @click="noAccessDialog = false">
                        OK, Mengerti
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="redeemDialog" persistent max-width="400">
            <v-card>
                <v-card-title class="headline primary--text">
                    <v-icon color="primary" class="mr-2">mdi-key-plus</v-icon>
                    Redeem Kode Buku
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="redeemCode"
                        label="Masukkan Kode Unik"
                        outlined
                        dense
                        :loading="redeemLoading"
                        :disabled="redeemLoading"
                        @keyup.enter="submitRedeem"
                    ></v-text-field>
                    <p class="caption grey--text">
                        Masukkan kode unik yang tertera di buku Anda
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="goToHome" :disabled="redeemLoading">
                        Batal
                    </v-btn>
                    <v-btn 
                        color="primary" 
                        @click="submitRedeem" 
                        :loading="redeemLoading"
                        :disabled="!redeemCode || redeemLoading"
                    >
                        Redeem
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

                <!-- ✅ NEW: Guru Info Not Set Dialog -->
        <v-dialog v-model="guruInfoNotSetDialog" persistent max-width="500">
            <v-card>
                <v-card-title class="headline warning--text">
                    <v-icon color="warning" class="mr-2" size="30">mdi-account-alert</v-icon>
                    Informasi Guru Belum Lengkap
                </v-card-title>
                <v-card-text>
                    <v-alert type="warning" outlined class="mb-3">
                        <div class="font-weight-bold mb-2">{{ guruInfoNotSetMessage }}</div>
                        <div class="text-body-2">
                            <v-icon small class="mr-1">mdi-information</v-icon>
                            {{ guruInfoDetails }}
                        </div>
                    </v-alert>
                    
                    <div class="text-body-2 grey--text text--darken-1">
                        <p class="mb-2">
                            <strong>Untuk melanjutkan akses ke buku ini:</strong>
                        </p>
                        <ul class="ml-4">
                            <li>Hubungi admin atau penerbit buku</li>
                            <li>Minta mereka melengkapi data guru pada sistem</li>
                            <li>Informasi yang diperlukan: Nama Guru dan Email Guru</li>
                        </ul>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="goToHome">
                        <v-icon left>mdi-home</v-icon>
                        Kembali
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

                <v-dialog v-model="paketCompletedDialog" persistent max-width="700">
            <v-card>
                <v-card-title class="headline success--text">
                    <v-icon color="success" class="mr-2" size="25">mdi-check-circle</v-icon>
                    Ujian Sudah Diselesaikan
                </v-card-title>
                
                <v-card-text>
                    <v-alert type="" outlined class="mb-4">
                        <div class="text-body-2">
                            Setiap paket ujian hanya dapat dikerjakan sekali.
                        </div>
                    </v-alert>
                    
                    <v-card outlined v-if="completionData">
                        <v-card-title class="subtitle-1 font-weight-bold primary--text">
                            Hasil Ujian Anda
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <div class="text-body-2 grey--text">Mata Pelajaran:</div>
                                    <div class="font-weight-bold">{{ completionData.mapel_name || 'N/A' }}</div>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="text-body-2 grey--text">Paket Ujian:</div>
                                    <div class="font-weight-bold">{{ completionData.paket_name || 'N/A' }}</div>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="text-body-2 grey--text">Skor:</div>
                                    <div class="font-weight-bold text-h5 success--text">
                                        {{ completionData.skor || 0 }}
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="text-body-2 grey--text">Kategori Nilai:</div>
                                    <div class="font-weight-bold">{{ completionData.kategori_nilai || 'N/A' }}</div>
                                </v-col>
                                <v-col cols="12" sm="6" v-if="completionData.waktu_pelaksanaan">
                                    <div class="text-body-2 grey--text">Waktu Pelaksanaan:</div>
                                    <div class="font-weight-bold">{{ completionData.waktu_pelaksanaan }}</div>
                                </v-col>
                                <v-col cols="12" sm="6" v-if="completionData.durasi_menit">
                                    <div class="text-body-2 grey--text">Durasi Pengerjaan:</div>
                                    <div class="font-weight-bold">{{ formatDuration(completionData.durasi_menit) }}</div>
                                </v-col>
                                <v-col cols="12">
                                    <div class="text-body-2 grey--text">Tanggal Penyelesaian:</div>
                                    <div class="font-weight-bold">{{ formatCompletedDate(completionData.completed_at) }}</div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                
                <v-card-actions>
                    <v-btn text @click="goBackToPaketList">
                        <v-icon left>mdi-chevron-left</v-icon>
                        Lihat Paket Lain
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="goToHome">
                        <v-icon left>mdi-home</v-icon>
                        Home
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-flex :class="{'py-2': $vuetify.breakpoint.smAndDown}">
            <v-layout row justify-center>
                <!-- Skeleton Loading -->
                <v-flex xs10 md10 xl8 v-if="loading">
                    <v-layout row wrap justify-content>
                        <v-flex xs12 class="mb-5">
                            <v-skeleton-loader type="button" width="120"></v-skeleton-loader>
                        </v-flex>
                        <v-flex xs12 class="mb-3">
                            <v-skeleton-loader type="card"></v-skeleton-loader>
                        </v-flex>
                        <v-flex xs12 lg6 class="pa-3" v-for="n in 3" :key="`skeleton-paket-${n}`">
                            <v-skeleton-loader type="list-item@3"></v-skeleton-loader>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs10 md10 xl8 v-if="!loading">
                    <v-layout row wrap justify-content>
                        <v-flex xs12 class="mb-5">
                            <v-row justify="space-between" align="center">
                                <v-col cols="auto">
                                    <v-btn class="text-none" depressed color="grey lighten-2" to="/">
                                        <v-icon>mdi-chevron-left</v-icon>Kembali
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-flex>
                        
                        <v-flex xs12 class="mb-3" v-if="expiryInfo.show">
                        <v-card 
                            :color="expiryInfo.color" 
                            :class="[expiryInfo.textClass, 'expiry-card']"
                            elevation="3"
                        >
                            <v-card-text class="py-3 px-4">
                            <div class="d-flex flex-column flex-md-row align-md-center justify-space-between">
                                
                                <div class="info-block">
                                <div class="d-flex align-center">
                                    <v-icon :color="expiryInfo.iconColor" class="mr-3" size="28">
                                    {{ expiryInfo.icon }}
                                    </v-icon>
                                    <div class="font-weight-bold text-subtitle-1">{{ expiryInfo.title }}</div>
                                </div>
                                <div class="caption ml-10 ">{{ expiryInfo.subtitle }}</div>
                                </div>

                                <v-chip 
                                v-if="expiryInfo.showCountdown"
                                :color="expiryInfo.chipColor" 
                                :text-color="expiryInfo.chipTextColor"
                                class="font-weight-bold mt-3 mt-md-0 justify-center"
                                :class="{ 'critical-warning': expiryInfo.critical }"
                                :block="$vuetify.breakpoint.smAndDown"
                                medium
                                >
                                <v-icon small left>mdi-timer</v-icon>
                                {{ countdown }}
                                </v-chip>
                                
                            </div>
                            </v-card-text>
                        </v-card>
                        </v-flex>

                        <v-flex xs12>
                            <v-layout row justify-center>
                                <v-flex xs12 :lg6="mapel.paket_ujian&&mapel.paket_ujian[item]" class="pa-3">
                                    <v-card :loading="loading">
                                        <v-toolbar color="primary" dark flat class="px-5">
                                            <v-toolbar-title>{{mapel.nama_mapel}}</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                        </v-toolbar>
                                        <v-card-text class="pa-0">
                                            <v-layout row justify-center v-if="mapel.paket_ujian&&mapel.paket_ujian[item]">
                                                <v-container :class="{'pa-2 fill-height': $vuetify.breakpoint.mdAndUp}">
                                                    <v-flex xs11 style="height:100%">
                                                        <v-layout row justify-center style="height:100%">
                                                            <v-container :class="{'fill-height pa-4': $vuetify.breakpoint.mdAndUp}" style="height:100%">
                                                                <v-list shaped width="100%" height="100%">
                                                                    <v-subheader class="ml-4 title font-weight-black">Daftar Isi</v-subheader>
                                                                    <v-list-item-group v-model="item" color="primary" mandatory class="scroll">
                                                                        <v-list-item
                                                                        v-for="paket in mapel.paket_ujian"
                                                                        :key="paket.id"
                                                                        >
                                                                            <v-list-item-content class="pl-4" @click="openInstruction">
                                                                                <v-list-item-title v-text="paket.nama_paket"></v-list-item-title>
                                                                            </v-list-item-content>
                                                                        </v-list-item>
                                                                    </v-list-item-group>
                                                                </v-list>
                                                            </v-container>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-container>
                                            </v-layout>
                                            <v-container class="fill-height" v-else>
                                                <v-layout row justify-center class="mt-4">
                                                    <p class="font-weight-bold title">Belum ada paket</p>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 lg6 class="pa-3" v-if="$vuetify.breakpoint.mdAndUp && mapel.paket_ujian&&mapel.paket_ujian[item]">
                                    <v-card :loading="loading">
                                        <v-toolbar color="primary" dark flat class="px-5">
                                            <v-toolbar-title>Petunjuk Penggunaan</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-btn color="accent" v-if="$vuetify.breakpoint.mdAndUp && mapel.paket_ujian&&mapel.paket_ujian[item]" @click="mulai">
                                                <span class="black--text font-weight-bold text-none">Mulai</span>
                                            </v-btn>
                                        </v-toolbar>
                                        <v-card-text>
                                            <v-container class="fill-height">
                                                <v-layout row justify-center>
                                                    <v-flex xs10>
                                                        <div class="text-center font-weight-bold dark-grey--text" v-if="mapel.paket_ujian&&mapel.paket_ujian[item]">
                                                            <p class="headline font-weight-bold">{{mapel.paket_ujian[item].nama_paket}}</p>
                                                            <p v-sanitize="mapel.paket_ujian[item].petunjuk"></p>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout row class="lighter-grey--text caption font-weight-thin mt-5 text-center" justify-center>
                        Copyright {{ new Date().getFullYear() }} © Grafindo Media Pratama. All Right Reserved.
                    </v-layout>
                </v-flex>
                
                <!-- Loading dialog -->
                <v-dialog v-model="loading" persistent width="300">
                    <v-card color="accent" dark>
                        <v-card-text class="pt-5">
                            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-flex>

        <v-snackbar
            v-model="successSnackbar"
            color="success"
            :timeout="4000"
            top
        >
            {{ successMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="successSnackbar = false">
                    Tutup
                </v-btn>
            </template>
        </v-snackbar>

        <v-snackbar
            v-model="errorSnackbar"
            color="error"
            :timeout="6000"
            top
        >
            {{ errorMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="errorSnackbar = false">
                    Tutup
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import * as api from '@/api'
import store from '../store/store'

export default {
    data(){
        return {
            loading: false,
            item: 0,
            dialog: false,
            mapel_id: this.$route.params.id,
            mapel: {},

            expiryDialog: false,
            expiryMessage: '',
            expiredDate: '',

            noAccessDialog: false,
            noAccessMessage: '',

            redeemDialog: false,
            redeemCode: '',
            redeemLoading: false,

            successSnackbar: false,
            successMessage: '',
            errorSnackbar: false,
            errorMessage: '',

            expiryDate: null,
            countdown: '',
            countdownTimer: null,

            // guruInfoDialog: false,
            // guruInfoLoading: false,
            // guruFormValid: false,
            // guruInfo: {
            //     nama_guru: '',
            //     email_guru: ''
            // },

            // editGuruDialog: false,
            // editGuruLoading: false,
            // editGuruFormValid: false,
            // editGuruInfo: {
            //     nama_guru: '',
            //     email_guru: ''
            // },
            
            // requiredRules: [
            //     v => !!v || 'Field ini wajib diisi'
            // ],
            // emailRules: [
            //     v => !!v || 'Email wajib diisi',
            //     v => /.+@.+\..+/.test(v) || 'Format email tidak valid'
            // ]

            guruInfoNotSetDialog: false,
            guruInfoNotSetMessage: '',
            guruInfoDetails: '',

            paketCompletedDialog: false,
            paketCompletedMessage: '',
            completionData: null,
        }
    },
    
    computed: {
        // ✅ NEW: Check if mapel has guru info
        hasGuruInfo() {
            return this.mapel && 
                   this.mapel.guru_info && 
                   this.mapel.guru_info.nama_guru && 
                   this.mapel.guru_info.email_guru
        },

        expiryInfo() {
            if (!this.expiryDate) {
                return { show: false }
            }

            const now = new Date()
            const expiry = new Date(this.expiryDate)
            const timeDiff = expiry - now
            // ✅ Selisih hari kalender, bukan pembulatan jam
            const daysDiff = this.calendarDaysUntil(expiry)

            if (timeDiff <= 0) {
                return {
                    show: true,
                    color: 'error',
                    textClass: 'white--text',
                    icon: 'mdi-alert-circle',
                    iconColor: 'white',
                    title: 'Paket Kadaluarsa',
                    subtitle: 'Paket ini sudah tidak dapat diakses',
                    showCountdown: false,
                    critical: true
                }
            } else if (daysDiff <= 1) {
                const isToday = daysDiff === 0
                const jam = this.formatTimeOnly(expiry)
                return {
                    show: true,
                    color: 'error',
                    textClass: 'white--text',
                    icon: 'mdi-clock-alert',
                    iconColor: 'white',
                    title: isToday ? 'Berakhir Hari Ini' : 'Berakhir Besok',
                    subtitle: isToday
                        ? `Segera selesaikan ujian Anda — paket berakhir hari ini pukul ${jam}`
                        : `Segera selesaikan ujian Anda — paket berakhir besok pukul ${jam}`,
                    showCountdown: true,
                    chipColor: 'white',
                    chipTextColor: 'error',
                    critical: true
                }
            } else if (daysDiff <= 3) {
                return {
                    show: true,
                    color: 'warning',
                    textClass: 'white--text',
                    icon: 'mdi-clock-alert-outline',
                    iconColor: 'white',
                    title: `Berakhir dalam ${daysDiff} Hari`,
                    subtitle: 'Waktu terbatas untuk menyelesaikan ujian',
                    showCountdown: true,
                    chipColor: 'white',
                    chipTextColor: 'warning',
                    critical: false
                }
            } else if (daysDiff <= 7) {
                return {
                    show: true,
                    color: 'orange',
                    textClass: 'white--text',
                    icon: 'mdi-clock-outline',
                    iconColor: 'white',
                    title: `Berakhir dalam ${daysDiff} Hari`,
                    subtitle: 'Rencanakan waktu ujian Anda',
                    showCountdown: true,
                    chipColor: 'white',
                    chipTextColor: 'orange',
                    critical: false
                }
            } else if (daysDiff <= 30) {
                return {
                    show: true,
                    color: 'blue',
                    textClass: 'white--text',
                    icon: 'mdi-information-outline',
                    iconColor: 'white',
                    title: `Berakhir dalam ${daysDiff} Hari`,
                    subtitle: 'Masih banyak waktu tersisa',
                    showCountdown: false,
                    critical: false
                }
            } else {
                return {
                    show: false
                }
            }
        }
    },
    
    async mounted(){
        await this.get()
        this.startCountdown()
    },
    
    beforeDestroy() {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer)
        }
    },
    
    methods:{
        async get(){
            this.loading = true
            
            await api.get('/mapel/'+this.mapel_id+'/paket', {}, async (res) => {
                if (res.data && res.data.error_code === 'EXPIRED') {
                    if (res.data.exp_date) {
                        this.expiryDate = res.data.exp_date
                    }
                    
                    this.expiryMessage = res.data.message || 'Paket sudah kadaluarsa'
                    this.expiredDate = res.data.expired_date || this.formatExpiredDate(res.data.exp_date)
                    this.expiryDialog = true
                    this.loading = false
                    return
                }
                
                if (res.data && (res.data.error_code === 'NO_ACCESS' || res.data.error_code === 'NOT_STARTED')) {
                    this.loading = false
                    this.handleAccessError(res.data)
                    return
                }

                if (res.data && res.data.error_code === 'GURU_INFO_NOT_SET') {
                    this.guruInfoNotSetMessage = res.data.message || 'Informasi guru belum lengkap'
                    this.guruInfoDetails = res.data.details.contact_info || 'Hubungi admin untuk melengkapi data guru'
                    this.guruInfoNotSetDialog = true
                    this.loading = false
                    return
                }
                
                // if (res.data && res.data.error_code === 'GURU_INFO_REQUIRED') {
                //     this.loading = false
                //     this.openGuruInfoDialog()
                //     return
                // }
                
                if (res.data && res.data.status !== false) {
                    this.mapel = res.data
                    this.extractExpiryDate(res.data)
                    this.loading = false
                } else {
                    this.loading = false
                    this.showError('Gagal memuat data paket')
                }
            })
        },

        openEditGuruDialog() {
            if (this.hasGuruInfo) {
                this.editGuruInfo = {
                    nama_guru: this.mapel.guru_info.nama_guru || '',
                    email_guru: this.mapel.guru_info.email_guru || ''
                }
                this.editGuruDialog = true
                this.editGuruFormValid = true
            } else {
                this.showError('Informasi guru belum tersedia')
            }
        },

        closeEditGuruDialog() {
            this.editGuruDialog = false
            this.editGuruInfo = {
                nama_guru: '',
                email_guru: ''
            }
            this.editGuruFormValid = false
        },

        async submitEditGuruInfo() {
            if (!this.$refs.editGuruForm.validate()) {
                return
            }
            
            if (this.expiryDate) {
                const now = new Date()
                const expiry = new Date(this.expiryDate)
                
                if (now > expiry) {
                    this.closeEditGuruDialog()
                    this.expiryMessage = 'Paket sudah kadaluarsa. Tidak dapat mengubah informasi guru.'
                    this.expiredDate = this.formatDate(expiry)
                    this.expiryDialog = true
                    return
                }
            }
            
            this.editGuruLoading = true

            await api.put('guru-info', {
                id_buku: this.mapel_id,
                nama_guru: this.editGuruInfo.nama_guru,
                email_guru: this.editGuruInfo.email_guru
            }, async (res) => {
                this.editGuruLoading = false
                
                if (res.status && res.data && res.data.status) {
                    this.showSuccess('Informasi guru berhasil diperbarui!')
                    this.closeEditGuruDialog()
                    
                    // ✅ RELOAD: Refresh data to ensure consistency
                    setTimeout(async () => {
                        await this.get() // Reload mapel data
                    }, 500)
                    
                } else {
                    const errorMsg = (res && res.data && res.data.message) 
                        ? res.data.message 
                        : 'Gagal memperbarui informasi guru'
                    this.showError(errorMsg)
                }
            }).catch(() => {
                this.editGuruLoading = false
                this.showError('Terjadi kesalahan saat memperbarui informasi guru')
            })
        },

        // Existing methods...
        formatExpiredDate(expDate) {
            if (!expDate) return null
            
            try {
                const date = new Date(expDate)
                return new Intl.DateTimeFormat('id-ID', {
                    timeZone: 'Asia/Jakarta',
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                    timeZoneName: 'short'
                }).format(date)
            } catch (error) {
                return expDate
            }
        },
        
        handleAccessError(errorData) {
            if (errorData.error_code === 'EXPIRED') {
                this.expiryMessage = errorData.message || 'Paket sudah kadaluarsa'
                this.expiredDate = errorData.expired_date || this.formatExpiredDate(errorData.exp_date)
                
                if (errorData.exp_date) {
                    this.expiryDate = errorData.exp_date
                }
                
                this.expiryDialog = true
            } else if (errorData.error_code === 'NO_ACCESS') {
                this.noAccessMessage = errorData.message || 'Anda tidak memiliki akses ke paket ini'
                this.noAccessDialog = true
            } else if (errorData.error_code === 'NOT_STARTED') {
                this.noAccessMessage = errorData.message || 'Ujian belum bisa diakses'
                this.noAccessDialog = true
            } else {
                this.showError(errorData.message || 'Terjadi kesalahan tidak dikenal')
            }
        },
        
        async mulai(){
            if (this.expiryDate) {
                const now = new Date()
                const expiry = new Date(this.expiryDate)
                
                if (now > expiry) {
                    this.expiryMessage = 'Paket sudah kadaluarsa. Silakan redeem kode baru.'
                    this.expiredDate = this.formatDate(expiry)
                    this.expiryDialog = true
                    return
                }
            }

            const paketId = this.mapel.paket_ujian[this.item].id
            await this.checkPaketCompletion(paketId)
            
            // store.commit('removeMapel')
            // this.$router.push('/paket/'+this.mapel_id+'/soal/'+paketId)
        },
        
        openInstruction() {
            this.dialog = true
        },
        
        openGuruInfoDialog() {
            if (this.expiryDate) {
                const now = new Date()
                const expiry = new Date(this.expiryDate)
                
                if (now > expiry) {
                    this.expiryMessage = 'Paket sudah kadaluarsa. Silakan redeem kode baru.'
                    this.expiredDate = this.formatDate(expiry)
                    this.expiryDialog = true
                    return
                }
            }
            
            this.guruInfoDialog = true
            this.guruInfo = {
                nama_guru: '',
                email_guru: ''
            }
        },
        
        async submitGuruInfo() {
            if (!this.$refs.guruForm.validate()) {
                return
            }
            
            if (this.expiryDate) {
                const now = new Date()
                const expiry = new Date(this.expiryDate)
                
                if (now > expiry) {
                    this.guruInfoDialog = false
                    this.expiryMessage = 'Paket sudah kadaluarsa. Silakan redeem kode baru.'
                    this.expiredDate = this.formatDate(expiry)
                    this.expiryDialog = true
                    return
                }
            }
            
            this.guruInfoLoading = true

            await api.post('guru-info', {
                id_buku: this.mapel_id,
                nama_guru: this.guruInfo.nama_guru,
                email_guru: this.guruInfo.email_guru
            }, async (res) => {
                this.guruInfoLoading = false
                
                if (res.status && res.data && res.data.status) {
                    this.showSuccess('Informasi guru berhasil disimpan! Memuat paket...')
                    this.guruInfoDialog = false
                    setTimeout(() => {
                        this.get()
                    }, 1000)
                } else {
                    const errorMsg = (res && res.data && res.data.message) 
                        ? res.data.message 
                        : 'Gagal menyimpan informasi guru'
                    this.showError(errorMsg)
                    
                    if (res.data && res.data.error_code === 'GURU_INFO_ALREADY_SET') {
                        this.guruInfoDialog = false
                        setTimeout(() => {
                            this.get()
                        }, 1500)
                    }
                }
            }).catch(() => {
                this.guruInfoLoading = false
                this.showError('Terjadi kesalahan saat menyimpan informasi guru')
            })
        },
        
        extractExpiryDate(data) {
            let expiryDate = null
            
            if (data.exp_date) {
                expiryDate = data.exp_date
            } else if (data.tgl_expired) {
                expiryDate = data.tgl_expired
            } else if (data.expiry_date) {
                expiryDate = data.expiry_date
            } else if (data.invoice_exp_date) {
                expiryDate = data.invoice_exp_date
            }
            
            if (expiryDate) {
                this.expiryDate = expiryDate
            }
        },
        
        /**
         * Selisih hari KALENDER (00:00 hari ini -> 00:00 tanggal target)
         * menurut zona Asia/Jakarta. 0 = hari ini, 1 = besok, dst.
         * Tidak dipengaruhi timezone device maupun jam saat ini.
         */
        calendarDaysUntil(date) {
            const dayIndex = (d) => {
                try {
                    const parts = new Intl.DateTimeFormat('en-CA', {
                        timeZone: 'Asia/Jakarta',
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                    }).formatToParts(d)
                    const get = (type) => parseInt(parts.find(p => p.type === type).value, 10)
                    return Date.UTC(get('year'), get('month') - 1, get('day'))
                } catch (e) {
                    // Fallback: WIB = UTC+7 tetap (tanpa DST)
                    const wib = new Date(d.getTime() + 7 * 60 * 60 * 1000)
                    return Date.UTC(wib.getUTCFullYear(), wib.getUTCMonth(), wib.getUTCDate())
                }
            }
            return Math.round((dayIndex(date) - dayIndex(new Date())) / (1000 * 60 * 60 * 24))
        },

        /** Jam:menit zona Asia/Jakarta tanpa AM/PM (mis. "17.00") */
        formatTimeOnly(date) {
            try {
                return new Intl.DateTimeFormat('id-ID', {
                    timeZone: 'Asia/Jakarta',
                    hour: '2-digit',
                    minute: '2-digit',
                    hourCycle: 'h23'
                }).format(date)
            } catch (e) {
                // Fallback: WIB = UTC+7 tetap (tanpa DST)
                const wib = new Date(date.getTime() + 7 * 60 * 60 * 1000)
                const hh = String(wib.getUTCHours()).padStart(2, '0')
                const mm = String(wib.getUTCMinutes()).padStart(2, '0')
                return `${hh}.${mm}`
            }
        },

        startCountdown() {
            this.updateCountdown()
            this.countdownTimer = setInterval(() => {
                this.updateCountdown()
            }, 1000)
        },
        
        updateCountdown() {
            if (!this.expiryDate) return
            
            const now = new Date()
            const expiry = new Date(this.expiryDate)
            const timeDiff = expiry - now
            
            if (timeDiff <= 0) {
                this.countdown = 'Kadaluarsa'
                if (this.countdownTimer) {
                    clearInterval(this.countdownTimer)
                }
                
                if (!this.expiryDialog) {
                    this.expiryMessage = 'Paket sudah kadaluarsa saat sedang diakses'
                    this.expiredDate = this.formatDate(expiry)
                    this.expiryDialog = true
                }
                return
            }
            
            const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
            const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))
            const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000)
            
            if (days > 0) {
                this.countdown = `${days} hari ${hours} jam`
            } else if (hours > 0) {
                this.countdown = `${hours} jam ${minutes} menit`
            } else if (minutes > 0) {
                this.countdown = `${minutes} menit ${seconds} detik`
            } else {
                this.countdown = `${seconds} detik`
            }
        },
        
        formatDate(date) {
            return new Intl.DateTimeFormat('id-ID', {
                timeZone: 'Asia/Jakarta',
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
                timeZoneName: 'short'
            }).format(date)
        },
        
        goToHome() {
            this.expiryDialog = false
            this.noAccessDialog = false
            this.guruInfoDialog = false
            this.editGuruDialog = false
            this.$router.push('/')
        },
        
        openRedeemDialog() {
            this.expiryDialog = false
            this.noAccessDialog = false
            this.guruInfoDialog = false
            this.editGuruDialog = false
            this.redeemDialog = true
            this.redeemCode = ''
        },
        
        closeRedeemDialog() {
            this.redeemDialog = false
            this.redeemCode = ''
        },
        
        async submitRedeem() {
            if (!this.redeemCode.trim()) {
                this.showError('Silakan masukkan kode unik')
                return
            }
            
            this.redeemLoading = true
            
            await api.post('auth/redeem-unique-code', {
                kode_unik: this.redeemCode.trim()
            }, async (res) => {
                this.redeemLoading = false
                
                if (res.status) {
                    if (res.data && res.data.status) {
                        this.showSuccess('Kode berhasil diredem! Memuat ulang halaman...')
                        this.closeRedeemDialog()
                        
                        setTimeout(() => {
                            window.location.reload()
                        }, 1500)
                    } else {
                        this.showError(res.data.message || 'Gagal redeem kode')
                    }
                } else {
                    this.showError('Gagal redeem kode')
                }
            }).finally(() => {
                this.redeemLoading = false
            })
        },
        
        showSuccess(message) {
            this.successMessage = message
            this.successSnackbar = true
        },
        
        showError(message) {
            this.errorMessage = message
            this.errorSnackbar = true
        },

        async checkPaketCompletion(paketId) {
        try {
            this.loading = true;
            
            await api.get(`/mapel/${this.mapel_id}/paket/${paketId}/soal`, {}, async (res) => {
            this.loading = false;
            
            if (!res || !res.data) {
                this.showError('Invalid response from server');
                return;
            }
            
            if (res.data.error_code === 'PAKET_ALREADY_COMPLETED') {
                this.paketCompletedMessage = res.data.message || 'Anda sudah pernah mengerjakan ujian paket ini';
                this.completionData = res.data.completion_data || null;
                this.paketCompletedDialog = true;
                return; 
            }

            if (res.data.error_code === 'NOT_STARTED') {
                this.noAccessMessage = res.data.message || 'Ujian belum bisa diakses';
                this.noAccessDialog = true;
                return;
            }

            if (res.data.error_code === 'EXPIRED') {
                this.expiryMessage = res.data.message || 'Paket sudah kadaluarsa';
                this.expiredDate = res.data.expired_date || '';
                this.expiryDialog = true;
                return;
            }

            if (res.data.status === false) {
                this.showError('Gagal memuat soal: ' + (res.data.message || 'Unknown error'));
                return; 
            }

            if (res.data && res.data.status !== false) {
                if (!res.data.soal || !Array.isArray(res.data.soal) || res.data.soal.length === 0) {
                this.showError('Data soal tidak valid atau kosong');
                return; 
                }

                store.commit('removeMapel'); 
                store.commit('setMapel', res.data); 
                
                this.$router.push('/paket/' + this.mapel_id + '/soal/' + paketId);
            } else {
                this.showError('Response tidak valid dari server');
            }
            });

        } catch (error) {
            this.loading = false;
            this.showError('Terjadi kesalahan saat memuat data');
        }
        },

        goBackToPaketList() {
            this.paketCompletedDialog = false
        },

        formatCompletedDate(isoString) {
            if (!isoString) return 'N/A'
            
            try {
                const date = new Date(isoString)
                return new Intl.DateTimeFormat('id-ID', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZone: 'Asia/Jakarta'
                }).format(date)
            } catch (error) {
                return isoString
            }
        },

        formatDuration(minutes) {
            if (!minutes || minutes === 0) return 'N/A'
            
            const hours = Math.floor(minutes / 60)
            const remainingMinutes = minutes % 60
            
            if (hours > 0) {
                return `${hours} jam ${remainingMinutes} menit`
            } else {
                return `${remainingMinutes} menit`
            }
        },
    }
}
</script>